import styled from "@emotion/styled";

export const LoaderBox = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: rgba(256, 256, 256, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
`;
